import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { JobComment } from '../model/jobComment';
import { HttpClient } from '@angular/common/http';
import { JobCommentSerializer } from '../model/serializer/jobComment-serializer';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class JobCommentServiceGet extends ApiService<JobComment> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'job-comment/job',
      new JobCommentSerializer());
  }
}
